import React from 'react';

const Testimonial = () => {
  return (
    <section 
      className="py-24 relative overflow-hidden bg-primary testimonial-bg-responsive"
      style={{
        backgroundImage: `url('https://acs.gedhemedia.com/ascttmb.webp')`,
        backgroundSize: 'cover',
        backgroundPosition: '22% center'
      }}
    >
      {/* Desktop Gradient: Transparent on the left (face), dark on the right (text) */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/10 to-primary/95 hidden lg:block pointer-events-none"></div>
      
      {/* Mobile Gradient: Increased transparency at the top to ensure face clarity */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/60 to-transparent lg:hidden pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Spacer to let the face show on desktop */}
          <div className="hidden lg:block h-80"></div>
          
          <div className="animate-in slide-in-from-right duration-700">
            {/* High contrast card with backdrop blur */}
            <div className="p-8 md:p-10 rounded-3xl bg-white/95 backdrop-blur-md border border-white/20 shadow-2xl">
              <blockquote className="text-xl lg:text-2xl font-medium leading-relaxed mb-10 italic text-primary">
                "Dengan Akademika Support, pekerjaan teknis saya jadi jauh lebih ringan. Hasil layout jurnal dan editing naskahnya sangat memuaskan."
              </blockquote>
              <div className="flex items-center space-x-4">
                <div className="w-14 h-14 rounded-full bg-primary flex items-center justify-center font-bold text-white shadow-lg">
                  AR
                </div>
                <div>
                  <p className="font-bold text-primary text-lg">Dr. Aulia Rahman</p>
                  <p className="text-secondary font-medium">Peneliti Senior</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (max-width: 1023px) {
            .testimonial-bg-responsive {
              /* Exactly center the face by targeting the 18% horizontal mark of the image */
              background-position: 18% center !important;
              /* Large top padding to create a dedicated 'stage' for the face */
              padding-top: 36rem !important;
              padding-bottom: 6rem !important;
            }
          }

          @media (max-width: 639px) {
            .testimonial-bg-responsive {
              /* Further adjust for very narrow screens like small phones */
              background-position: 16% center !important;
              padding-top: 32rem !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Testimonial;